export const MainRoutes = {
  HOME: "/home",
  METRIC_DASHBOARD: "/analysis",
  METRICS_TIMELINE: "/metrics-timeline",
  DOCUMENTS: "/documents",
  DOCUMENT_DETAILS: "/documents/:id",
  CONTRACT_DOCUMENT_CONFIG: "/documents/:id/config",
  WELCOME: "/welcome",
  USERS: "/users",
  SIMILAR_REQUIREMENTS: "/documents/:id/similar-requirements",
  DOCUMENT_SETUP: "/document-setup",
  BULK_UPLOAD: "/bulk-upload",
  CONFIGURE: "/configure",
  PROCESSING: "/processing-upload/:id",
  UPLOAD_GDX: "/processing-upload-gdx/:id",
  // VIEW_SUMMARY: "/view-summary",
  CONFIGURE_OPS: "/configure-ops",
  DOCUMENT_OPERATION: "/configure-ops/document-operation",
  EXTRACTION_CONFIGURATION: "/extraction-config",
  AVAILABLE_TOOLS: "/extraction-config/available-tools",
  TOOL_VALIDATION: "/extraction-config/available-tools/validate/:toolId",
  TOOL_DEVELOPMENT: "/extraction-config/available-tools/tool-development",
  ASSIGNMENT: "/assignment",
  TAG_LIBRARY_CONFIG: "/tag-library-config",
  CREATE_TAG_LIBRARY_CONFIG: "/tag-library-config/create",
  TAG_ENRICHMENT_PHASE: "/tag-library-config/enrich",
  COMPLETE_TAG_LIBRARY_CONFIG: "/tag-library-config/complete",
  PROCESSING_HUB: "/processing-hub",
  AI_CHATBOT: "/ai-chatbot",
  DATA_INTEGRATION_HUB: "/data-integration-hub",
  DATA_CLASSIFICATION_HUB: "/classification-hub/upload",
  DATA_CLASSIFICATION_HISTORY: "/classification-hub",
  DATA_CLASSIFICATION_RESULTS: "/classification-hub/results/:batchGuid",
  DATA_CLASSIFICATION_DETAIL:
    "/classification-hub/category/:category/:batchGuid",
  BATCH_EXTRACTION_RESULTS:
    "/classification-hub/quality/batch-extraction-results",
  BATCH_QUALITY_ASSESSMENT:
    "/classification-hub/quality/batch-quality-assessment",
  AVAILABLE_DETAILS: "/data-integration/available-details",
  DATA_FILTER_BUILDER: "/data-integration/filter-builder",
  DATA_MAPPING_INTERFACE: "/data-integration/mapping-interface",
  PREDICTIVE_MAINTENANCE_DASHBOARD: "/data-integration/predictive-maintenance",
  FLOW_BUILDER: "/data-integration/flow-builder",
  SNOWFLAKE_DATA_VIEWER: "/data-integration/snowflake-viewer",
  KNOWLEDGE_LIBRARY: "/knowledge-library",
  VIEW_KNOWLEDGE_DATA: "/knowledge-library/view-data",
  SEARCH_DETAILS: "/search-details",
  AI_SEARCH_HUB: "/ai-search-hub",
  KNOWLEDGE_AGENT: "/knowledge-agent/create-session",
  AGENT_ALL_DETAILS: "/knowledge-agent/all-details",
  AGENT_SESSION_VIEW: "/knowledge-agent/:sessionId",
  PACKAGING_WORKSPACE: "/packaging-workspace",
  MANAGEMENT_OF_CHANGE: "/management-of-change",
  CREATE_MOC: "/management-of-change/create",
  RELATIONSHIP_VALIDATION: "/relationship-validation/:id",
  DRAWING_INTELLIGENCE: "/drawing-intelligence/:id",
  CREATE_ONTOLOGY: "/create-ontology",
  CREATE_ONTOLOGY_INITIATIVE: "/ontology-studio/create",
  CREATE_ONTOLOGY_QUESTIONS: "/ontology-studio/create/questions",
  CREATE_ONTOLOGY_CQ_REVIEW: "/ontology-studio/create/cq-review",
  CREATE_ONTOLOGY_ENTITIES_RELATIONSHIPS:
    "/ontology-studio/create/entities-relationships",
  CREATE_ONTOLOGY_REUSE_HARMONISATION:
    "/ontology-studio/create/reuse-harmonisation",
  CREATE_ONTOLOGY_GROUND_TO_DOCUMENTS:
    "/ontology-studio/create/ground-to-documents",
  CREATE_ONTOLOGY_BUILD_KNOWLEDGE_GRAPH:
    "/ontology-studio/create/build-knowledge-graph",
  CREATE_ONTOLOGY_VALIDATE_RELEASE: "/ontology-studio/create/validate-release",
  ONTOLOGY_LIBRARY: "/ontology-studio/library"
  // DATA_ANALYSIS_HUB: "/data-analysis-hub"
};

const HOME_ROUTE = {
  BASE: MainRoutes.HOME
};

const USERS_ROUTE = {
  BASE: MainRoutes.USERS
};

export const ROUTE_PATH = {
  COOKIE_SETTINGS: "cookie-settings",
  COOKIE_POLICY: "cookie-policy"
};

const PAGES_ALLOWED_BEFORE_COOKIE_CONSENT = [
  `/${ROUTE_PATH.COOKIE_SETTINGS}`,
  `/${ROUTE_PATH.COOKIE_POLICY}`
];

const ROUTES = {
  DEFAULT: "/",
  WILD: "*",
  HOME: HOME_ROUTE,
  USERS: USERS_ROUTE,
  NOT_FOUND: "/notfound"
};

export { ROUTES, PAGES_ALLOWED_BEFORE_COOKIE_CONSENT };
